import { Injectable } from '@angular/core';
@Injectable()
export class Entitlements {
  static AtAGlance = [
    'ViewCuiAtAGlance',
  ];
  static AlertsAndNotifications = [
    'ViewCuiAlertsAndNotifications',
  ];
  static QuickActions = [
    'ViewCuiQuickActions',
  ];
  static StopPaymentRequest = [
    'CuiStopPaymentRequest',
  ];
  static ViewEmployeePay = [
    'PsgViewEmployeePay',
  ];
  static ViewCompanies = [
    'PsgViewCompanies'
  ];
}
